module.exports = __webpack_public_path__ + "static/media/oh-no.28987551.png";